/* ELC Shift — Store-context helpers module (wave 3, slice 5).
   Extracted verbatim from index.html's inline HELPERS block. Behaviour-preserving:
   each function was a global inline declaration, so all are re-exposed on window.
   Reads app globals (currentStore, ALL_STAFF, ALL_STORES) and the date helpers
   (getMonday/getSunday from dates.js) by bare name at call-time. Loaded EARLY —
   before the bundles that call these (screens, logs, checklists, rota, clock, …). */
(function(){

function isQatarStore(store) {
  return getStoreCountry(store||currentStore||'') === 'ELC - Qatar';
}
function getWeekStart(d) {
  return isQatarStore(currentStore) ? getSunday(d) : getMonday(d);
}
// Display order of days — Sun-first for Qatar, Mon-first for UAE
function getDisplayDays() {
  return isQatarStore(currentStore)
    ? ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
    : ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
}
function initials(name) { return (name||'').split(' ').filter(Boolean).map(function(w){return w[0];}).join('').slice(0,2).toUpperCase(); }

// Bug A (v80.X): when multiple staff share a first name (e.g. Ahmed, Mohammed),
// showing only first names makes them indistinguishable in rota/clock/balance
// views. This helper disambiguates by returning a map of id→display string:
//   • first name unique within list → "First"
//   • first name collides           → "First Last" (full surname, per the bug
//                                     reporter's expected output)
// Called once per render with the per-store staff list. No global state.
function computeDisplayNames(staffList) {
  var result = {};
  if (!Array.isArray(staffList)) return result;
  var byFirst = {};
  staffList.forEach(function(s){
    if (!s || !s.name) return;
    var first = String(s.name).trim().split(/\s+/)[0];
    if (!first) return;
    if (!byFirst[first]) byFirst[first] = [];
    byFirst[first].push(s);
  });
  Object.keys(byFirst).forEach(function(first){
    var group = byFirst[first];
    if (group.length === 1) {
      result[group[0].id] = first;
    } else {
      group.forEach(function(s){
        var parts = String(s.name).trim().split(/\s+/);
        var last = parts.length > 1 ? parts[parts.length - 1] : '';
        result[s.id] = last ? (first + ' ' + last) : first;
      });
    }
  });
  return result;
}
function getStoreCountry(store) { var s=ALL_STAFF.find(function(x){return x.store===store;}); return s?s.country:'ELC - UAE'; }
// D3 (weekly checklist): a template whose frequency_config lists multiple
// week-start days (e.g. ['Mon','Sun'], to cover both GCC countries) must be due
// on only ONE day per store — the day matching that store's country week-start
// (UAE = Monday, Qatar = Sunday). Otherwise every store sees it due TWICE and
// the unused day shows as "missed" (Arabian Centre, 2 Jun 2026: done Sunday,
// reads not-done Tuesday). Returns the single due-day abbreviation.
function weeklyDueDayForStore(days, store) {
  if (!Array.isArray(days) || !days.length) return 'Mon';
  if (days.length === 1) return days[0];
  var isQatar = false;
  try { isQatar = getStoreCountry(store || (typeof currentStore !== 'undefined' ? currentStore : '') || '') === 'ELC - Qatar'; } catch (e) {}
  var preferred = isQatar ? 'Sun' : 'Mon';
  return days.indexOf(preferred) !== -1 ? preferred : days[0];
}
function pct(mins,total) { return Math.max(0,Math.min(100,(mins/total)*100)).toFixed(2)+'%'; }

// ── re-expose (preserves the pre-extraction global surface) ──
window.isQatarStore = isQatarStore;
window.getWeekStart = getWeekStart;
window.getDisplayDays = getDisplayDays;
window.initials = initials;
window.computeDisplayNames = computeDisplayNames;
window.getStoreCountry = getStoreCountry;
window.weeklyDueDayForStore = weeklyDueDayForStore;
window.pct = pct;

})();

// ── PUBLIC_HOLIDAYS — moved VERBATIM from index.html (v128.37, refactor R10) ──
// Sole-reader data constant (never written cross-bundle, so the "state
// stays declared in the HTML" law does not apply). Window-bound so any
// classic-script or cross-bundle bare reference keeps resolving.
var PUBLIC_HOLIDAYS = {
  UAE: [
    {date:'2026-01-01', name:'New Years Day'},
    {date:'2026-03-19', name:'Eid Al Fitr (Day 1)'},
    {date:'2026-03-20', name:'Eid Al Fitr (Day 2)'},
    {date:'2026-03-21', name:'Eid Al Fitr (Day 3)'},
    {date:'2026-05-26', name:'Arafat Day'},
    {date:'2026-05-27', name:'Eid Al Adha (Day 1)'},
    {date:'2026-05-28', name:'Eid Al Adha (Day 2)'},
    {date:'2026-05-29', name:'Eid Al Adha (Day 3)'},
    {date:'2026-06-15', name:'Islamic New Year'},
    {date:'2026-08-24', name:'Prophets Birthday'},
    {date:'2026-11-30', name:'Commemoration Day'},
    {date:'2026-12-02', name:'National Day'},
    {date:'2026-12-03', name:'National Day'},
  ],
  Qatar: [
    {date:'2026-01-01', name:'New Years Day'},
    {date:'2026-02-10', name:'National Sports Day'},
    {date:'2026-03-19', name:'Eid Al Fitr (Day 1)'},
    {date:'2026-03-20', name:'Eid Al Fitr (Day 2)'},
    {date:'2026-03-21', name:'Eid Al Fitr (Day 3)'},
    {date:'2026-05-26', name:'Arafat Day'},
    {date:'2026-05-27', name:'Eid Al Adha (Day 1)'},
    {date:'2026-05-28', name:'Eid Al Adha (Day 2)'},
    {date:'2026-05-29', name:'Eid Al Adha (Day 3)'},
    {date:'2026-06-15', name:'Islamic New Year'},
    {date:'2026-08-24', name:'Prophets Birthday'},
    {date:'2026-12-18', name:'Qatar National Day'},
  ]
};
if (typeof window !== "undefined") window.PUBLIC_HOLIDAYS = PUBLIC_HOLIDAYS;
